











































































































































import i18n from "../../../locale";
import { Dictionary } from "lodash";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { ACTION } from ".";
import {
  ApiMessage,
  CustomersApi, EquipmentModel,
  GetCustomersResponse,
  GetLocationsCustomerResponse,
  GetLocationUnitsResponse,
  JobModel,
  JobsApi,
  LocationsApi,
} from "../../../apis";
import moment from "moment/moment";

extend("file-type", {
  validate: () => {
    return true;
  },
  message: i18n.t("message.invalid").toString(),
});

@Component({
  components: { ValidationProvider, ValidationObserver },
})
export default class AddJob extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({}) mode: ACTION;
  @Prop({ default: {} }) selectedJob: JobModel;
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  getCustomersResponse: GetCustomersResponse = null;
  getLocationsCustomerResponse: GetLocationsCustomerResponse = null;
  getLocationUnitsResponse: GetLocationUnitsResponse = null;
  formJob?: {
    customerId?: string;
    locationId?: string;
    jobName?: string;
    maintenanceDate?: string;
    files?: File[];
    notes?: string[];
  } = {};
  isRemoveFile = false;
  isViewMode = false;

  get apiMessages(): Dictionary<ApiMessage[]> {
    return this.$store.getters.apiMessages;
  }

  @Watch("apiMessages", { deep: true })
  apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
    this.$util.showApiError(messages, this.observer);
  }

  get show() {
    this.formJob = {
      customerId: "",
      locationId: "",
      jobName: "",
      maintenanceDate: "",
      files: [],
      notes: [""],
    };
    return this.value;
  }

  set show(value) {
    if (this.observer) this.observer.reset();
    this.$emit("input", value);
  }

  get CUSTOMERS(): { text: string; value: string }[] {
    return this.getCustomersResponse
      ? this.getCustomersResponse.data.map((val) => ({
          value: val.id,
          text: val.companyName,
        }))
      : [];
  }

  get LOCATIONS() {
    return this.getLocationsCustomerResponse
      ? this.getLocationsCustomerResponse.data.map((val) => ({
          value: val.id,
          text: val.locationName,
        }))
      : [];
  }

  @Watch("formJob.customerId")
  async onCustomerIdWatch(newVal: string) {
    if (!newVal) return;
    this.getLocationsCustomerResponse = (
      await new CustomersApi().getActiveLocationsByCustomerId({
        id: this.formJob.customerId,
      })
    ).data;
  }

  clearAllFile() {
    this.isRemoveFile = true;
  }

  onChangeFile(files: any) {
    this.formJob.files = files;
  }

  onAddNote() {
    this.formJob.notes.push("");
    setTimeout(() => {
      if (this.formJob.notes.length - 1 > -1) {
        const ref = this.$refs[`focus${this.formJob.notes.length - 1}`][0];
        if (ref) {
          ref.focus();
        }
      }
    }, 200);
  }

  onRemoveNote (index) {
    console.log(index);
    this.formJob.notes.splice(index, 1);
  }

  async onSubmit() {
    const formatDate = (dateStr) =>
      moment(dateStr, "YYYY-MM-DD HH:mm").utc().format("YYYY-MM-DD HH:mm");
    const valid = await this.observer.validate();
    if (!valid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    this.$util.showLoading();
    try {
      if (this.mode === ACTION.ADD) {
        await new JobsApi().addJob({
          files: this.formJob.files,
          customerId: this.formJob.customerId,
          locationId: this.formJob.locationId,
          jobName: this.formJob.jobName,
          maintenanceDate: this.formJob.maintenanceDate ? formatDate(this.formJob.maintenanceDate): "",
          notes: this.formJob.notes
        });
      }
      if (this.mode === ACTION.EDIT) {
        await new JobsApi().putJob({
          removeFile: this.isRemoveFile,
          id: this.selectedJob.id,
          files: this.formJob.files,
          customerId: this.formJob.customerId,
          locationId: this.formJob.locationId,
          jobName: this.formJob.jobName,
          maintenanceDate: this.formJob.maintenanceDate ? formatDate(this.formJob.maintenanceDate): "",
          notes: this.formJob.notes
        });
      }
      this.show = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onShow() {
    this.getCustomersResponse = (await new CustomersApi().getActiveCustomers()).data;
    if (this.mode === ACTION.EDIT) {
      this.formJob.customerId = this.selectedJob.customer.id;
      this.formJob.locationId = this.selectedJob.location.id;
      this.formJob.jobName = this.selectedJob.jobName;
      this.formJob.notes = this.selectedJob.notes.map(note => note);
      this.formJob.maintenanceDate = this.selectedJob.maintenanceDate ? moment(this.selectedJob.maintenanceDate).format(
        "YYYY-MM-DD HH:mm"
      ) : undefined;
      if (this.selectedJob.attachFileNames) {
        this.formJob.files = this.selectedJob.attachFileNames.map((file) => new File(
          [],
          file
        ));
      }
    }
  }
}
